import { Component, OnInit } from '@angular/core';
import { AfiliacionService } from 'src/app/services/afiliacion/afiliacion.service';
import { PostulacionesService } from 'src/app/services/postulaciones/postulaciones.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { isNullOrUndefined } from 'util';
import { environment } from '../../../environments/environment';
import { PagosService } from 'src/app/services/pagos/pagos.service';
import { ProductosService } from 'src/app/services/productos/productos.service';
import {FormsModule} from '@angular/forms';
import { Postulaciones } from '../../models/postulaciones/postulaciones.model';
import { Afiliado } from '../../models/afiliado/afiliado.model';


export interface DialogData
{
    tipoCarga: any
    recarga: boolean
}

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';


@Component({
  selector: 'app-solicitudes-afiliacion',
  templateUrl: '../../pages/listado-pendientes/solicitudes-afiliacion.component.html',
  styleUrls: ['../../pages/listado-pendientes/solicitudes-afiliacion.component.css']
})
export class SolicitudesAfiliacionComponent implements OnInit 
{
    rol:string = localStorage.getItem("rol")
    nombreUsuario: string = localStorage.getItem("nombreUsuario")

    config: any = { itemsPerPage: 10, currentPage: 1, totalItems: 0, indexInicial: 0, indexMaximo: 10 }
  
    postulaciones: any = []
    afiliados: any = []
  
    productos: any = []
    idProducto: any = 1
    totalizado: any = 0
    fechaPagoGrupo: any
    agrupadorProductos: any = []
    currentDate: any
  
    
    allComplete: boolean = false

    constructor(private afiliacionService: AfiliacionService,private pagosService: PagosService, private postulacionesService: PostulacionesService,
                private dialog: MatDialog, private productosService: ProductosService) { }

    ngOnInit(): void 
    {
        let vm = this
        this.currentDate    = new Date(Date.now()).getTime();
        this.loadData()
    }

    loadData()
    {
        let vm = this
    
        vm.allComplete=false;      
        vm.postulaciones = [] 
        this.totalizado=0;
        this.total=0;
        this.afiliacionService.traePostulaciones().then
        (
            (postulaciones: any) =>
            { 
                postulaciones.forEach(postulacion => { postulacion.seleccionado = false })
                vm.postulaciones = postulaciones
                vm.config.totalItems = postulaciones.length
            }
        )
        .catch 
        ( 
            error => 
            {
                console.log(error)

                if(error.status == 404)
                {
                    this.openAlertDialog("No hay registros disponibles para pago con el producto seleccionado", "btn-danger")
                }
            }
        )
    }
    
    someComplete(): boolean 
    {   
      
        if (this.postulaciones.seleccionado == null) { return false }

        return this.postulaciones.filter(p => p.seleccionado).length > 0 && !this.allComplete
    }
    
    setAll(seleccionado: boolean) 
    {
        this.allComplete = seleccionado
        
        if (this.postulaciones == null) { return }       
     //   this.total=0;
        for(let i = this.config.indexInicial; i < this.config.indexMaximo; i++)
        {         
            if(this.postulaciones[i]){
                this.postulaciones[i] ? this.postulaciones[i].seleccionado = seleccionado : null
                  if(seleccionado)
                      this.total+=this.postulaciones[i].montoReembolso;
                  else
                      this.total-=this.postulaciones[i].montoReembolso;
            }
         
        }
        this.totalizado= this.total;
    }

    updateAllComplete() 
    {        
        this.allComplete =  this.postulaciones != null && this.postulaciones
                            .slice(this.config.indexInicial, this.config.indexMaximo)
                            .every(p => p.seleccionado)
    }
    total = 0;
    actualizaTotal(postulacion) {       
        if(postulacion.seleccionado) {
          this.total += postulacion.montoReembolso;
        } else {
          this.total -= postulacion.montoReembolso;
        }
        if(isNaN(this.total)){
            this.total=0;
        } 
        this.totalizado=this.total;
    }


    enviarPostulacionesSeleccionadas()
    {
        let postulacionesSeleccionadas: [] = this.postulaciones.filter( pos => pos.seleccionado )
        let fechaPago = this.fechaPagoGrupo
        let idUsuario = localStorage.getItem("idUsuario")

        if(postulacionesSeleccionadas.length == 0)
        {
            this.openAlertDialog("Debe seleccionar al menos una afiliación pendiente.", "btn-danger")
            return
        }

        if(isNullOrUndefined(fechaPago))
        {
            this.openAlertDialog("Debe seleccionar la fecha de afiliación.", "btn-danger")
            return
        }
        else 
        { 
            fechaPago = this.fechaPagoGrupo.split('-')[2] + '-' + this.fechaPagoGrupo.split('-')[1] + '-' + this.fechaPagoGrupo.split('-')[0]
        }

      

       
        let fechaInicio = new Date( fechaPago.split('-')[2] + '-' +
        fechaPago.split('-')[1] + '-' +
        fechaPago.split('-')[0]+'T24:00').getTime();   

        fechaPago = fechaPago.split('-')[2] + '-' + fechaPago.split('-')[1] + '-' + fechaPago.split('-')[0]
     
        let fechaActual    = new Date(Date.now()).getTime();
        /*
        if(fechaInicio < fechaActual )
        {
            this.openAlertDialog("La fecha seleccionada no debe ser menos a la fecha actual.", "btn-danger")
            return
        }
        */

        let vm = this
        let postulacionesSimplificadas= this.simplificaPostulacion(postulacionesSeleccionadas)

        this.afiliacionService.creaGrupoAfiliado(fechaPago, idUsuario, postulacionesSimplificadas).then
        (
            () => 
            {
                vm.openAlertDialog("La agrupación de afiliados pendientes ha sido generada, en los próximos minutos estará disponible", "btn-success")
                vm.loadData()
            }
        )
        .catch
        (
            error => 
            {
                console.log(error)

                vm.openAlertDialog("Ha ocurrido un error al generar la agrupación de pago.", "btn-danger")
            }
        )
    }

    verArchivo(postulacionId: any)
    {
        let vm = this
    
        this.postulacionesService.traeArchivos(postulacionId).then
        (
            (archivos: any) =>
            {                
                archivos.forEach( archivo => {
                    var fileURL=`${environment.urlBlob}/${archivo.url}`             
                    window.open(fileURL);
                })  
               
            }
        )
        .catch 
        ( 
            error =>  
            {
                console.log(error)

                vm.openAlertDialog('Ha ocurrido un error para visualizar el archivo.', 'btn-danger')
            }
        )        
    }

    openAlertDialog(mensaje: string, clase: string)  
    {
        const dialogRef = this.dialog.open(AlertDialogComponent, 
        {
            data: 
            {              
                message: mensaje,
                clase: clase,
                buttonText: { cancel: 'Listo!' },
            }
        })
    }

    pageChanged(event: any) 
    { 
        this.config.currentPage = event 
        
        this.config.indexInicial = ( (this.config.currentPage - 1) * this.config.itemsPerPage)
        this.config.indexMaximo = ( this.config.currentPage * this.config.itemsPerPage )

        this.updateAllComplete()
    }

    cambiaCantidadRegistros()
    {
        this.config.indexInicial = 0, this.config.indexMaximo = this.config.itemsPerPage, this.config.currentPage = 1 
    }

    simplificaPostulacion(postulacion) {  
    var postulaciones2:Afiliado []= new Array()  ;  
        for (var i = 0; i < postulacion.length; i++) {
                postulaciones2.push({ rut: postulacion[i].rut,dv: postulacion[i].dv} );
        }
    return postulaciones2;
    }
}